import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../../imageService';

const ResultScreen = () => {
  return (
    <div className={styles.container}>
      <p className={styles.title}>Дякуємо за приділений час!</p>
      <p className={styles.description}>Сподіваємося, що було корисно.</p>
      <img src={getImageFromS3('images/ghws/result.png')} alt="result" />
    </div>
  );
};

export default ResultScreen;
